<div class="barcode justify-content">
  <div
    *ngIf="media"
    class="justify-content"
    style="position: relative; height: 100%"
  >
    <div
      style="
        margin: 0;
        position: relative;
        top: 50%;
        left: 0px;
        transform: translate(0, -50%);
        right: 0px;
      "
    >
      <span class="id">Nr. {{ media.id }}</span
      ><span class="class"
        ><span style="color: #888">{{ createDate }}&emsp;</span
        ><span
          *ngIf="
            Library &&
            Library.configuration &&
            Library.configuration.barcodeDimensions.showClass
          "
          >{{ media.mediaClass.sign
          }}<span
            *ngIf="
              Library &&
              Library.configuration &&
              Library.configuration.barcodeDimensions.showAuthor
            "
            >, {{ Author }}</span
          ></span
        ></span
      ><br />
      <span class="title">{{ media.title }}</span>

      <br />
      <div>
        <div>
          <svg #barcode></svg><br />
          <span class="library">{{ media.library.label }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
